'use client'

// next/dynamic's `ssr: false` is only allowed inside a Client Component.
// This module is the client boundary for the job page's client-only store hydration.
import nextDynamic from 'next/dynamic'

const JobStore = nextDynamic(() => import('./job-store'), { ssr: false })

export default JobStore
